/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindSupplierMappingQueryResponse,
  FindSupplierMappingQueryParams,
} from "../types/FindSupplierMapping.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findSupplierMappingQueryKey = (
  params: FindSupplierMappingQueryParams
) =>
  [
    { url: "/v1/client-settings/find-supplier-mapping" },
    ...(params ? [params] : []),
  ] as const

export type FindSupplierMappingQueryKey = ReturnType<
  typeof findSupplierMappingQueryKey
>

/**
 * @summary Find contact
 * {@link /v1/client-settings/find-supplier-mapping}
 */
export async function findSupplierMapping(
  params: FindSupplierMappingQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindSupplierMappingQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/client-settings/find-supplier-mapping`,
    params,
    ...requestConfig,
  })
  return res
}

export function findSupplierMappingQueryOptions(
  params: FindSupplierMappingQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findSupplierMappingQueryKey(params)
  return queryOptions<
    ResponseConfig<FindSupplierMappingQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindSupplierMappingQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findSupplierMapping(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find contact
 * {@link /v1/client-settings/find-supplier-mapping}
 */
export function useFindSupplierMapping<
  TData = ResponseConfig<FindSupplierMappingQueryResponse>,
  TQueryData = ResponseConfig<FindSupplierMappingQueryResponse>,
  TQueryKey extends QueryKey = FindSupplierMappingQueryKey,
>(
  params: FindSupplierMappingQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindSupplierMappingQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findSupplierMappingQueryKey(params)

  const query = useQuery(
    {
      ...findSupplierMappingQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
